import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
// import { NestedTreeControl } from '@angular/cdk/tree';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
// import { MatPaginator } from '@angular/material/paginator';
// import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
// import { MatTable, MatTableDataSource } from '@angular/material/table';
// import { DataSourceService } from 'src/app/services/dataSource.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { UserRoleProcessing } from 'src/app/models/usermanagement/userroleprocessing';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
import { MatCheckboxRendererComponent } from 'src/app/mat-checkbox-renderer';

interface Group {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-userrolemapping',
  templateUrl: './userrolemapping.component.html',
  styleUrls: ['./userrolemapping.component.scss']
})
export class UserrolemappingComponent implements OnInit {
  // @ViewChild(MatTable) table!: MatTable<UserRoleProcessing>;
  // @ViewChild(MatPaginator) paginator!: MatPaginator;
  // @ViewChild(MatSort) sort!: MatSort;

  RMList!: any[];
  GroupList!: any[];
  submitData!: any[];
  UsersList!: any[];
  GroupId!: number;
  selectedRowIndex!: any;
  // userRoleData!: MatTableDataSource<UserRoleProcessing>;
  userRoleForm!: FormGroup;
  status: Group[] = [
    { value: 'None', viewValue: 'None' },
  ];
  userRoleProcessingData: UserRoleProcessing[] = [];
  // userRoleGroupColumns: string[] = ['RoleId', 'RoleName', 'Access'];
  // userRolesData = new MatTableDataSource<UserRoleProcessing>();
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  filteredGroups: any;
  filteredUsers: any;

  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;
  frameworkComponents: any;
  isDisable = true;
  languageDir = 'ltr';
  langObj: any = {};
  lang: any;
  moduleId!: any;
  pageId!:any;
  gridOptions: any = {
   defaultColDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- & HERE
      minWidth: 225,
    },
    medalColumn: {
      width: 100,
      columnGroupShow: 'open',
      filter: false,
    },
    popupParent: document.querySelector('body'),
    floatingFilter: true,
  };
  public excelStyles!: any;

  // tslint:disable-next-line: no-shadowed-variable
  constructor(private formBuilder: FormBuilder,
    // private DataSourceService: DataSourceService,
    private userService: UserManagementService,
    private kpiMaster: KpimasterService,
    public router: Router,

    private roleService: UserManagementService,
    private toaster: ToastrService,
    public translater: TranslaterService,
    public translate: TranslateService,
    )
    {
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
  
        if (event.lang === 'ar') {
          this.languageDir = 'rtl';
          this.getLangWords();
        } else if (event.lang === 'en') {
          this.languageDir = 'ltr';
          this.getLangWords();
        } else if (event.lang === 'fr') {
          this.languageDir = 'ltr';
          this.getLangWords();
        } else if (event.lang === 'sp') {
          this.languageDir = 'ltr';
          this.getLangWords();
        }
      });
      this.frameworkComponents = {
        checkboxRenderer: MatCheckboxRendererComponent,

      };
    }

  ngOnInit(): void {
    this.datasource();
    // this.getUserslist();
    this.RMList = [];
    this.userRoleForm = this.formBuilder.group({
      userGroup: [''],
      UserName: [''],
    });


    this.GetBreadcrumList();
    this.GetMenuAccess();
  }

  // breadCrumb

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.kpiMaster.GetMenuAccess(key).subscribe((data: any) => {
      // this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
      this.columnDefs = [
        {
          headerName: 'Access',
          field: 'IsRoleMap',
          cellRenderer: 'checkboxRenderer',
          cellRendererParams: {
            clicked: this.setAll.bind(this),
            label: 'select',
          },
          editable:true,
          maxWidth: 100,
          minWidth: 50,
          cellStyle: { textAlign: 'left' },
          // hide: !this.IsWrite,
          suppressMenu: true,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Role Id',
          field: 'RoleId',
          filter: 'agTextColumnFilter',
          hide: true,
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Role Name',
          field: 'RoleName',
          filter: 'agTextColumnFilter',
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Assigned By',
          field: 'AssignedBy',
          filter: 'agTextColumnFilter',
          headerValueGetter: this.localizeHeader.bind(this)
        },
        {
          headerName: 'Assigned Date',
          field: 'AssignedDate',
          filter: 'agTextColumnFilter',
          valueFormatter: function (params: any) { return moment(params.value).format('MM/DD/YYYY HH:mm:ss')},
          headerValueGetter: this.localizeHeader.bind(this)
        },
      ];
      this.excelStyles = [
        {
          id: 'header',
          interior: {
            color: '#a47ed9',
            pattern: 'Solid',
          },
        },
        {
          id: 'body',
          interior: {
            color: '#d1c1e8',
            pattern: 'Solid',
          },
        },
      ];

    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.roleService.GetBreadcrumList(obj).subscribe((data: any) => {
      this.breadcrumList = data.BreadcrumList;
      this.moduleId = this.breadcrumList[0].id;
      this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
      this.getLangWords();
      this.lang = new Multilingual(this.translater, this.translate);
      this.lang.getLangWords();
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
    // return false;
  }

  getUserRoles(): void {
    const data = {
      UserId: this.userRoleForm.value.UserName,
      GroupId: this.userRoleForm.value.userGroup
      //  UserId : this.userRoleForm.value.UserName !== undefined ?  this.userRoleForm.value.UserName : this.GroupId
    };

    // tslint:disable-next-line: no-shadowed-variable
    this.userService.getRoleMapData(data).subscribe((response: any) => {
      // this.userRoleData = new MatTableDataSource<UserRoleProcessing>(response.RoleMapList);
      this.rowData = response.RoleMapList;
      // this.getPaginator();
    }, (error) => {
      this.toaster.error('Error', error.message);
    });
  }
  // Getting Group Data
  datasource(): void {
    const key = {
      Id: 0
    };
    // tslint:disable-next-line: no-debugger
    this.userService.getGroupData(key).subscribe((data: any) => {
      this.GroupList = data.masterList;
      this.GroupId = this.GroupList[0].TypeId;
      this.filteredGroups = this.GroupList.slice();
      this.getUserslist();
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  }

  getUserslist(): void {
    const key = {
      // GroupId : this.userRoleForm.value.userGroup
      GroupId: this.GroupId
    };
    this.userService.getUsersData(key).subscribe((data: any) => {
      this.UsersList = data.UserList;
      this.filteredUsers = this.UsersList.slice();
      // this.GroupId = this.GroupList[0].TypeId;
      // this.getUserRoles();
    }, (error: any) => {
      this.toaster.error('error', error.error.message);
    });
  }

  // applyFilter(event: Event): void {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.userRoleData.filter = filterValue.trim().toLowerCase();

  //   if (this.userRoleData.paginator) {
  //     this.userRoleData.paginator.firstPage();
  //   }
  // }



  onSubmit(): void {
    this.RMList = [];
    // tslint:disable-next-line: no-unused-expression
    this.rowData.map((x) => {
      if ((x.IsRoleMap === true) || (x.IsRoleMap === x.RoleId)) {
        this.RMList.push({
          UserId: this.userRoleForm.value.UserName,
          RoleId: x.RoleId
        });
      }
    });

    const obj = {
      RMList: this.RMList,
      UserId: this.userRoleForm.value.UserName
    };
    // tslint:disable-next-line: align
    this.userService.SumbitRoleMap(obj).subscribe((data: any) => {
      if (data.HasError)
        this.toaster.error('Error', data.ErrorMessage);
      else {
        this.toaster.success('Data Saved Successfuly', data.ErrorMessage);

        this.getUserRoles();

        var params = {
          force: true,
          suppressFlash: true,
        };

        this.gridApi.redrawRows();        
        

      }
    }, (error) => {
      this.toaster.error('Error', error.message);
    });
    // tslint:disable-next-line: no-trailing-whitespace

    // tslint:disable-next-line: no-trailing-whitespace

  }

  // getPaginator(): void {
  //   setTimeout(() => {
  //     this.userRoleData.paginator = this.paginator;
  //     this.userRoleData.sort = this.sort;
  //   }, 1000);
  // }

  setAll(event: any): void {
    if (event === true) {
      this.selectedRowIndex.IsRoleMap = this.selectedRowIndex.RoleId;
    }
    else {
      this.selectedRowIndex.IsRoleMap = null;
    }
  }

  highlight(row: any): void {
    this.selectedRowIndex = row;
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }
  
  getTransalatedValue(value:string){
    let val;
    if(this.langObj && this.langObj[value]){
      val = this.langObj[value];
    }
    return val?val:value;
  }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  excelExport() {
    let params: any = {
      columnKeys: ['Access', 'RoleId', 'RoleName', 'AssignedBy', 'AssignedDate'],
      allColumns: false,
      skipHeader: false,
      //customFooter: '\n \n Total No.Of records :' + this.gridOptions.api.getModel().getRowCount() + ' \n'
    };
    params.processCellCallback = function (cellParams: any) {
      if (cellParams && cellParams.column.colId === 'AssignedDate')
        return cellParams.value !== null ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A') : '';
      else
        return cellParams.value // no formatting
    }
    this.gridApi.exportDataAsExcel(params);
  }
  
  csvExport() {
    let params: any = {
      columnKeys: ['Access', 'RoleId', 'RoleName', 'AssignedBy', 'AssignedDate'],
      allColumns: false,
      skipHeader: false,
      //customFooter: '\n \n Total No.Of records :' + this.gridOptions.api.getModel().getRowCount() + ' \n'
    };
    params.processCellCallback = function (cellParams: any) {
      if (cellParams && cellParams.column.colId === 'AssignedDate')
        return cellParams.value !== null ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A') : '';
      else
        return cellParams.value // no formatting
    }
    this.gridApi.exportDataAsCsv(params);
  }


}
